module.exports = __webpack_public_path__ + "images/darkIntro.71e32349.svg";